import { useState } from 'react';
import { useTranslation } from 'react-i18next';


const Rooms = ({ relacionados, ruta, lang }) => {
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        (relacionados.length > 0) ?
            <>
                <h2 className="text-center h1">{t("Relacionadas")}</h2>
                <app-hotel-room-by-type >
                    <div className="c-swiper-rooms o-cont-fullw">
                        <div className="container">

                            <div className="mb-3 tab-content">
                                <div ngbnavpane="" id="ngb-nav-0-panel" aria-labelledby="ngb-nav-0" className={`tab-pane fade active show`}>
                                    <div className="c-rooms-grid">
                                        {relacionados.map((propiedadrel, index) => (
                                            <div className="c-room" key={propiedadrel.id || index}>
                                                <figure >
                                                    <img src={`${ruta}/propiedades/${propiedadrel.id}/fotos/web/${propiedadrel.foto_principal[0].nombre}`} alt={propiedadrel.nombre} />
                                                </figure>
                                                <div className="c-room-info">
                                                    <h3 className="c-room-title">{propiedadrel.nombre}</h3>
                                                    <p ></p>
                                                    <div className="o-list-btns">
                                                        <button type="button" className="btn btn-secondary">
                                                            <span>{t("Detalles")}</span>
                                                            <span className="o-icon o-icon-2" >
                                                                <i className="fa-solid fa-arrow-right"></i>
                                                            </span>
                                                        </button>
                                                        <a className="btn btn-primary" href={`/${preidioma}${t("apartamentos")}-${propiedadrel.destino.url_dinamica[lang]}/${propiedadrel.url_dinamica}`}>{t("Ver disponibilidad")}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                            <div className="d-flex justify-content-center">
                                <a className="btn btn-secondary" href={`/${preidioma}${t("buscar")}`}>{t("Ver todas las habitaciones")}</a>
                            </div>


                        </div>
                    </div>
                </app-hotel-room-by-type>
            </>
            :
            ""
    );
};

export default Rooms;
